export default __webpack_public_path__ + "static/media/app-bookings.f77f8739.png";